{
  "cp.components.appDrawer.drawerCourses": "Cursos",
  "cp.components.appDrawer.drawerExport": "Exportar",
  "cp.components.appDrawer.drawerImprint": "Términos",
  "cp.components.appDrawer.drawerInstitutes": "Centros de formación",
  "cp.components.appDrawer.drawerSettings": "Ajustes",
  "cp.components.appDrawer.drawerShares": "Compartir",
  "cp.components.appDrawer.drawerSingleTrainings": "Formaciones",
  "cp.components.appDrawer.drawerTrainees": "Alumnos",
  "cp.components.appDrawer.drawerTrainers": "Instructores",
  "cp.components.changePassword.changePasswordButton": "Cambiar contraseña",
  "cp.components.changePassword.currentPassword": "Contraseña actual",
  "cp.components.changePassword.equalError": "La nueva contraseña es la misma que la anterior.",
  "cp.components.changePassword.matchError": "Las nuevas contraseñas no coinciden",
  "cp.components.changePassword.newPassword": "Nueva contraseña",
  "cp.components.changePassword.newPasswordRepeat": "Nueva contraseña (Repetir)",
  "cp.components.changePassword.newRequiredError": "Se requiere una nueva contraseña",
  "cp.components.changePassword.newToShortError": "La contraseña proporcionada es demasiado corta.",
  "cp.components.changePassword.requiredError": "Se requiere la contraseña actual",
  "cp.components.changePassword.setPasswordButton": "Establecer contraseña",
  "cp.components.changeUserRole.errorSnackbar": "Se ha producido un error desconocido. Vuelve a intentarlo o ponte en contacto con el servicio de asistencia si el error persiste.",
  "cp.components.changeUserRole.selectLabel": "Elegir rol",
  "cp.components.changeUserRole.successSnackbar": "Se cambió el rol a {role}",
  "cp.components.courseTable.deleteLabel": "Eliminar",
  "cp.components.courseTable.downloadCSVTitle": "Descargar archivo CSV",
  "cp.components.courseTable.downloadMessage": "Curso seleccionado para descargar",
  "cp.components.courseTable.selected": "Seleccionado",
  "cp.components.courseTable.tableRowAssociatedTrainer": "Instructor asociado",
  "cp.components.courseTable.tableRowDate": "Fecha",
  "cp.components.courseTable.tableRowIdentifier": "ID del Curso",
  "cp.components.courseTable.tableRowLocation": "Ubicación",
  "cp.components.courseTable.tableRowProvider": "Proveedor de formación",
  "cp.components.courseTable.tableRowTraineeCount": "Recuento de alumnos",
  "cp.components.courseTable.tableRowValue": "Valor",
  "cp.components.dialog.confirmDeletion.contentConclusion": "La eliminación es permanente. Esta cuenta ya no estará disponible.",
  "cp.components.dialog.confirmDeletion.contentDescription": "Estás a punto de eliminar una cuenta con los siguientes roles:",
  "cp.components.dialog.confirmDeletion.title": "¿Eliminar la cuenta seleccionada?",
  "cp.components.footer.rightsReserved": "Todos los derechos reservados",
  "cp.components.general.institutePageSnackbarError": "Error al guardar el centro de formación",
  "cp.components.general.institutePageSnackbarSuccess": "Guardado",
  "cp.components.general.snackbar.emailAllreadySentSnackbar": "El correo electrónico se envió en los últimos 10 minutos. Espere antes de poder enviar otro.",
  "cp.components.general.tableRowName": "Nombre",
  "cp.components.genericTable.emptyMessage": "Vacío",
  "cp.components.genericTable.multiSelect": "Seleccionar todo",
  "cp.components.genericTable.nextPage": "Página siguiente",
  "cp.components.genericTable.previousPage": "Página anterior",
  "cp.components.genericTable.rowsPerPageLabel": "Filas por página",
  "cp.components.genericTable.searchPlaceholder": "Buscar",
  "cp.components.imprint.pageTitle": "Términos de uso",
  "cp.components.instituteAdminTable.adminsTableEmail": "Email",
  "cp.components.instituteAdminTable.adminsTableInviteButton": "Invitar al administrador",
  "cp.components.instituteAdminTable.adminsTableSubtitle": "Usuarios autorizados a gestionar el centro de formación",
  "cp.components.instituteAdminTable.adminsTableTitle": "Administradores",
  "cp.components.instituteAdminTable.deleteAdminMessage": "¿Realmente quieres eliminar al administrador seleccionado? Esto será permanente.",
  "cp.components.instituteAdminTable.deleteLabel": "Eliminar",
  "cp.components.instituteAdminTable.deleteTrainerMessage": "¿Realmente quieres eliminar al instructor seleccionado? Será permanente.",
  "cp.components.instituteAdminTable.name": "Nombre",
  "cp.components.instituteAdminTable.selected": "Seleccionado",
  "cp.components.instituteForm.institute": "Instituto",
  "cp.components.instituteForm.instituteAddress": "Dirección del Centro de Formación",
  "cp.components.instituteForm.instituteCity": "Ciudad",
  "cp.components.instituteForm.instituteCountry": "País",
  "cp.components.instituteForm.instituteName": "Nombre del Centro de Formación",
  "cp.components.instituteForm.instituteSaveButton": "Guardar",
  "cp.components.instituteForm.instituteState": "Provincia",
  "cp.components.instituteForm.instituteStreet": "Calle y número de la casa",
  "cp.components.instituteForm.instituteStreetAdditional": "Adición a la dirección",
  "cp.components.instituteForm.instituteZIP": "Código postal",
  "cp.components.instituteForm.localeDanish": "danés (Dansk)",
  "cp.components.instituteForm.localeEnglish": "Inglés",
  "cp.components.instituteForm.localeFinish": "Suomi",
  "cp.components.instituteForm.localeFrench": "Francés",
  "cp.components.instituteForm.localeGerman": "Alemán",
  "cp.components.instituteForm.localeItalian": "Italiano",
  "cp.components.instituteForm.localeLabel": "Idioma",
  "cp.components.instituteForm.localeSpanish": "Espanol",
  "cp.components.instituteResultConfig.button": "Configurar la retroalimentación de los resultados",
  "cp.components.instituteResultConfig.info": "Estos cambios se aplican a todo el Centro de Formación. Para que esto suceda, los instructores deben volver a iniciar la sesión en la aplicación CorPatch® Trainer. ",
  "cp.components.instituteResultConfig.save": "Guardar configuración",
  "cp.components.instituteResultConfig.thresholdGood": "Nivel bueno",
  "cp.components.instituteResultConfig.thresholdGreat": "Nivel: Excelente",
  "cp.components.instituteTrainerTable.button": "Invita a un instructor",
  "cp.components.instituteTrainerTable.deleteLabel": "Eliminar",
  "cp.components.instituteTrainerTable.name": "Name",
  "cp.components.instituteTrainerTable.selected": "Seleccionado",
  "cp.components.instituteTrainerTable.subtitle": "Todos los formadores que pertenecen al Centro de Formación\n",
  "cp.components.instituteTrainerTable.tableRowsStreet": "Calle",
  "cp.components.instituteTrainerTable.title": "Instructores",
  "cp.components.instituteTrainerTable.trainerEmptyMessage": "Aún no hay instructores",
  "cp.components.invite.inviteCancelButton": "Cancelar",
  "cp.components.invite.inviteEmailRequired": "Email",
  "cp.components.invite.inviteEmailSend": "Enviado",
  "cp.components.invite.inviteEmailSent": "Email enviado",
  "cp.components.invite.inviteFirstnameLabel": "Nombre",
  "cp.components.invite.inviteInvalidEmail": "Este no es un correo electrónico válido.",
  "cp.components.invite.inviteOk": "OK",
  "cp.components.invite.inviteSendButton": "Enviar invitación",
  "cp.components.invite.inviteSubheader": "Se enviará una invitación a esta dirección de correo electrónico.",
  "cp.components.invite.inviteSurnameLabel": "Apellido",
  "cp.components.navBar.menuLabel": "Menú",
  "cp.components.passwordForgotSetPassword.changePasswordButton": "Cambiar contraseña",
  "cp.components.passwordForgotSetPassword.matchError": "Las nuevas contraseñas no coinciden",
  "cp.components.passwordForgotSetPassword.newPassword": "Nueva contraseña",
  "cp.components.passwordForgotSetPassword.newPasswordRepeat": "Nueva contraseña (Repetir)",
  "cp.components.passwordForgotSetPassword.newRequiredError": "Se requiere una contraseña nueva",
  "cp.components.passwordForgotSetPassword.newToShortError": "La contraseña proporcionada es demasiado corta.",
  "cp.components.reminder.app.appAppStoreButton": "Ir a la App Store de Apple",
  "cp.components.reminder.app.appPlayStoreButton": "Ir a Google Play Store",
  "cp.components.reminder.app.content": "Para usar tu CorPatch®, necesitas la aplicación CorPatch®. Descárgala de Google Playstore o App Store. \n",
  "cp.components.reminder.app.title": "¿Quieres empezar? ¡Descarga la aplicación!",
  "cp.components.reminder.title": "CorPatch®",
  "cp.components.reminder.welcome": "Bienvenido",
  "cp.components.resetPassword.changePasswordButton": "Cambiar contraseña",
  "cp.components.resetPassword.currentPassword": "Contraseña actual",
  "cp.components.resetPassword.equalError": "La nueva contraseña es la misma que la anterior",
  "cp.components.resetPassword.matchError": "Las nuevas contraseñas no coinciden",
  "cp.components.resetPassword.newPassword": "Nueva contraseña",
  "cp.components.resetPassword.newPasswordRepeat": "Nueva contraseña (Repetir)",
  "cp.components.resetPassword.newRequiredError": "Se requiere una contraseña nueva",
  "cp.components.resetPassword.requiredError": "Se requiere la contraseña actual",
  "cp.components.resetPassword.setPasswordButton": "Establecer contraseña",
  "cp.components.singleTrainingsTable.shareDialogContent": "Selecciona el instituto con el que quieres compartir esta formación:",
  "cp.components.singleTrainingsTable.shareDialogTitle": "Compartir formación",
  "cp.components.singleTrainingsTable.shareDialogTooltip": "Compartir formación",
  "cp.components.singleTrainingsTable.sharedDialogCancelButton": "Cancelar",
  "cp.components.singleTrainingsTable.sharedDialogShareButton": "Compartir",
  "cp.components.singleTrainingsTable.sharedDialogTooltip": "Compartido en: ",
  "cp.components.singleTrainingsTable.tableRowDate": "Fecha",
  "cp.components.singleTrainingsTable.tableRowDepth": "Profundidad",
  "cp.components.singleTrainingsTable.tableRowFlow": "Circulación",
  "cp.components.singleTrainingsTable.tableRowFrequency": "Frecuencia",
  "cp.components.singleTrainingsTable.tableRowOrigin": "Formación",
  "cp.components.singleTrainingsTable.tableRowRecoil": "Reexpansión",
  "cp.components.singleTrainingsTable.tableShareTrainingTooltip": "Compartir formación",
  "cp.components.userMenu.email": "Email",
  "cp.components.userMenu.logout": "Cerrar sesión",
  "cp.components.userMenu.password": "Contraseña",
  "cp.pages.acceptInvitation.button": "A la página de inicio de sesión",
  "cp.pages.acceptInvitation.message": "¡Todo listo para empezar!",
  "cp.pages.acceptInvitation.pageNotFound.message": "Esta invitación ya no es válida.",
  "cp.pages.acceptInvitation.pageNotFound.title": "No se encontró la invitación",
  "cp.pages.acceptInvitation.title": "Listo",
  "cp.pages.acceptInvitation.welcome": "Bienvenido",
  "cp.pages.adminInvite.errorSnackbar": "El correo electrónico ya se está utilizando",
  "cp.pages.adminInvite.inviteCardTitle": "Invitar al administrador",
  "cp.pages.adminInvite.successSnackbar": "Enviar correo electrónico a {email}",
  "cp.pages.admins.adminsEmpty.button": "Invitar al administrador",
  "cp.pages.admins.adminsEmpty.message": "¿Quieres invitar al primer administrador del Centro de Formación?",
  "cp.pages.admins.adminsEmpty.selected": "Seleccionado",
  "cp.pages.admins.adminsEmpty.tableRowEmail": "Correo electrónico",
  "cp.pages.admins.adminsEmpty.tableRowName": "Nombre",
  "cp.pages.admins.adminsEmpty.title": "Aún no hay administradores",
  "cp.pages.admins.adminsNotFound.message": "Se ha eliminado este Centro de Formación. ",
  "cp.pages.admins.adminsNotFound.title": "No encontrado",
  "cp.pages.admins.instituteAdmin": "Institute Admin",
  "cp.pages.admins.tableRowInstitute": "Centro de Formación",
  "cp.pages.admins.title": "Admins",
  "cp.pages.course.cellDate": "Fecha",
  "cp.pages.course.cellDuration": "Duración",
  "cp.pages.course.cellFeedback": "Respuesta",
  "cp.pages.course.cellName": "Nombre",
  "cp.pages.course.rowDepth": "Profundidad",
  "cp.pages.course.rowFlow": "Circulación",
  "cp.pages.course.rowFrequency": "Frecuencia",
  "cp.pages.course.rowRecoil": "Reexpansión",
  "cp.pages.course.title": "Curso",
  "cp.pages.course.trainees": "{{count}} alumnos",
  "cp.pages.courses.errorSnackbar": "No se pudo eliminar este curso.",
  "cp.pages.courses.pageNotFoundMessage": "Se borró. Lo siento :(",
  "cp.pages.courses.pageNotFoundTitle": "No encontrado",
  "cp.pages.courses.pageTitle": "Cursos",
  "cp.pages.courses.roleInstituteAdmin": "Administrador del Centro de Formación",
  "cp.pages.courses.roleTrainee": "Alumno",
  "cp.pages.courses.successSnackbar": "El curso se ha eliminado correctamente.",
  "cp.pages.dashboard.cpsCount": "dispositivos CorPatch® activos",
  "cp.pages.dashboard.cpsCountRecently": "nuevo CorPatch® conectado",
  "cp.pages.dashboard.lastMonth": "Desarrollo durante el último mes.",
  "cp.pages.dashboard.mobilesCount": "Todos los móviles reconocidos",
  "cp.pages.dashboard.mobilesCountRecently": "móviles recientes",
  "cp.pages.dashboard.pageTitle": "Estadísticas",
  "cp.pages.dashboard.trainingsCount": "formaciones completadas",
  "cp.pages.dashboard.usersCount": "cantidad total de usuarios registrados",
  "cp.pages.dashboard.usersCountRecently": "nuevos usuarios registrados",
  "cp.pages.email.validation.button": "Ir a Inicio de sesión",
  "cp.pages.email.validation.text": "Gracias por verificar tu dirección de correo electrónico. La usaremos para mantener tu cuenta segura y mantenerte al día si lo deseas.",
  "cp.pages.export.pageTitle": "Exportar curso",
  "cp.pages.homepage.title": "Página de inicio",
  "cp.pages.institute.PageNotFound.message": "Este Centro de Formación se ha eliminado y ya no se puede editar.",
  "cp.pages.institute.PageNotFound.title": "No se encontró el Centro de Formación.",
  "cp.pages.institute.institute": "Centro de Formación",
  "cp.pages.institute.snackbarError": "Error al guardar el Centro de Formación",
  "cp.pages.institute.snackbarSuccess": "Guardado",
  "cp.pages.institute.tabsAdmins": "Administradores",
  "cp.pages.institute.tabsBaseData": "Datos básicos",
  "cp.pages.institute.tabsTrainers": "Instructores",
  "cp.pages.instituteAdminShares.active": "Active",
  "cp.pages.instituteAdminShares.deleted": "Deleted",
  "cp.pages.instituteAdminShares.endDate": "Fin",
  "cp.pages.instituteAdminShares.noActiveSharingObjectsMessage": "No tiene ningún objeto para compartir activo.",
  "cp.pages.instituteAdminShares.noDeletedSharingObjectsMessage": "No se han eliminado objetos para compartir.",
  "cp.pages.instituteAdminShares.pageNotFoundMessage": "Las acciones que busca no existen.",
  "cp.pages.instituteAdminShares.pageTitle": "Compartir",
  "cp.pages.instituteAdminShares.pageTitleNotFound": "No encontrado",
  "cp.pages.instituteAdminShares.startDate": "Iniciar",
  "cp.pages.institutes.addInstituteButton": "Añadir Centro de Formación",
  "cp.pages.institutes.deleteLabel": "Eliminar",
  "cp.pages.institutes.errorSnackbar": "No se pudo eliminar el Centro de Formación",
  "cp.pages.institutes.pageNotFound.message": "¿Quieres añadir el primer Centro de Formación?",
  "cp.pages.institutes.pageNotFound.title": "No se encontró ningún Centro de Formación",
  "cp.pages.institutes.pageTitle": "Centros de Formación",
  "cp.pages.institutes.successSnackbar": "El Centro de Formación se ha eliminado correctamente.",
  "cp.pages.institutesTable.deleteWarning": "¿Quieres eliminar el Centro de Formación seleccionado? ¡Se perderán todas las cuentas y datos asociados!",
  "cp.pages.institutesTable.instituteLowercase": "centro de Formación",
  "cp.pages.institutesTable.institutesLowercase": "centros de Formación",
  "cp.pages.institutesTable.tableRowCity": "Ciudad",
  "cp.pages.institutesTable.tableRowCountry": "País",
  "cp.pages.institutesTable.tableRowInstitutes": "Centros de Formación",
  "cp.pages.institutesTable.tableRowName": "Nombre",
  "cp.pages.institutesTable.tableRowStreet": "Calle",
  "cp.pages.institutesTable.tableRowZIP": "Código postal",
  "cp.pages.internalServerError.button": "Reintentar",
  "cp.pages.internalServerError.message": "El servidor no pudo completar la solicitud. Esto depende de nosotros. Inténtelo de nuevo más tarde.",
  "cp.pages.internalServerError.title": "Por favor, inténtelo de nuevo más tarde",
  "cp.pages.login.email": "Correo electrónico",
  "cp.pages.login.loginButton": "Entrar",
  "cp.pages.login.loginInstitutesTitle": "Centros de Formación",
  "cp.pages.login.password": "Contraseña",
  "cp.pages.login.passwordForgot": "¿Olvidó la contraseña?",
  "cp.pages.login.registerButton": "Registrarse",
  "cp.pages.login.termsOfUseButton": "Términos de uso",
  "cp.pages.login.userNewlyRegisteredLabel1": "Te has registrado correctamente.",
  "cp.pages.login.userNewlyRegisteredLabel2": "No olvides confirmar tu dirección de correo electrónico e iniciar sesión de inmediato.",
  "cp.pages.login.userOrPasswordNotFound": "No se encontró el usuario o la contraseña",
  "cp.pages.login.validate.errorContent": "Puede que hayas intentado iniciar sesión desde otro navegador o dispositivo o que hayas cerrado tu navegador mientras tanto. Intenta solicitar otro correo electrónico para iniciar sesión.",
  "cp.pages.login.validate.errorSnackbar": "Se ha producido un error al iniciar sesión. Es posible que tu enlace esté desactualizado.",
  "cp.pages.login.validate.errorTitle": "No hemos podido reconocer la sesión de su navegador",
  "cp.pages.login.validate.successContent": "Espere un momento mientras validamos su inicio de sesión.",
  "cp.pages.login.validate.successTitle": "Estamos iniciando sesión.",
  "cp.pages.login.validate.validationButton": "Volver a iniciar sesión",
  "cp.pages.login.validate.validationContent": "Le hemos enviado un correo electrónico para verificar su inicio de sesión.",
  "cp.pages.login.validate.validationTitle": "Verifique su inicio de sesión",
  "cp.pages.logout.loginButton": "Entrar",
  "cp.pages.logout.message": "¡Hasta la próxima!",
  "cp.pages.logout.title": "¡Adiós!",
  "cp.pages.me.deleteOwnButtonConfirm": "Elimina tu cuenta de forma permanente",
  "cp.pages.me.deleteOwnButtonRequest": "Eliminar tu cuenta de forma permanente",
  "cp.pages.me.deleteOwnContent": "Esta acción eliminará tu cuenta de forma permanente. Asegúrate de haber guardado todos los datos que podrían perderse al eliminar tu cuenta. Tenga en cuenta que no puedes anular esta acción.",
  "cp.pages.me.familyName": "Apellido",
  "cp.pages.me.firstName": "Nombre",
  "cp.pages.me.gender": "Género",
  "cp.pages.me.genderFemale": "Mujer",
  "cp.pages.me.genderMale": "Hombre",
  "cp.pages.me.genderOther": "Otro",
  "cp.pages.me.notFoundTitle": "Configuración de la cuenta",
  "cp.pages.me.save": "Guardar",
  "cp.pages.me.snackBarSaved.error": "Error al guardar la configuración de la cuenta ",
  "cp.pages.me.snackBarSaved.saved": "Guardado",
  "cp.pages.me.title": "Configuración de la cuenta",
  "cp.pages.networkError.pageNotFound.button": "Reintentar",
  "cp.pages.networkError.pageNotFound.message": "El servidor no pudo completar la solicitud. ¿Está conectado a Internet?",
  "cp.pages.networkError.pageNotFound.title": "Parece que el servidor no funciona. ¡Esto depende de nosotros! Vuelva a intentarlo más tarde. ",
  "cp.pages.notFound.message": "No se pudo encontrar esta página.",
  "cp.pages.notFound.title": "No encontrado",
  "cp.pages.passwordForgot.confirmationMessage": "El correo electrónico de verificación se enviará a tu cuenta.",
  "cp.pages.passwordForgot.confirmationMessage2": "por favor revísala.",
  "cp.pages.passwordForgot.confirmationSendMessage": "Te hemos enviado un correo electrónico con un enlace de aprobación a",
  "cp.pages.passwordForgot.confirmationSent": "Enviar correo electrónico",
  "cp.pages.passwordForgot.confirmationTitle": "Restablece tu contraseña",
  "cp.pages.passwordForgot.eMail": "Correo electrónico",
  "cp.pages.passwordForgot.passwordForgotBackToLogin": "Volver a inicio de sesión",
  "cp.pages.passwordForgot.passwordForgotTitle": "¿Has olvidado la contraseña?",
  "cp.pages.passwordForgotSetPassword.button": "A la página de inicio de sesión",
  "cp.pages.passwordForgotSetPassword.message": "¡Todo listo para empezar!",
  "cp.pages.passwordForgotSetPassword.pageNotFound.message": "Este código ya no es válido.",
  "cp.pages.passwordForgotSetPassword.pageNotFound.title": "Ya no es válido",
  "cp.pages.passwordForgotSetPassword.title": "Contraseña cambiada",
  "cp.pages.passwordForgotSetPassword.welcome": "Bienvenido",
  "cp.pages.register.acceptTermsOfUse": "¿Aceptas las condiciones de uso?",
  "cp.pages.register.create": "Crear cuenta",
  "cp.pages.register.emailField": "Correo electrónico",
  "cp.pages.register.errorSnackbar": "Se ha producido un error no intencionado. Por favor, inténtelo de nuevo.",
  "cp.pages.register.firstnameField": "Nombre",
  "cp.pages.register.lastnameField": "Apellido",
  "cp.pages.register.newToShortError": "La contraseña proporcionada es demasiado corta.",
  "cp.pages.register.passwordField": "Contraseña",
  "cp.pages.register.successSnackbar": "Tu registro se ha realizado correctamente.",
  "cp.pages.settings.feedbackMode.menuItemExpert": "Barra",
  "cp.pages.settings.feedbackMode.menuItemNone": "Ninguno",
  "cp.pages.settings.feedbackMode.menuItemSimple": "Compresión",
  "cp.pages.settings.menuItemThresholdGood": "El nivel de valoración es «bueno»",
  "cp.pages.settings.menuItemThresholdGreat": "El nivel de valoración es «Excelente»",
  "cp.pages.settings.resultType.menuItemExpert": "Experto",
  "cp.pages.settings.resultType.menuItemNone": "Ninguno",
  "cp.pages.settings.resultType.menuItemSimple": "Sencillo",
  "cp.pages.settings.resultType.menuItemStandard": "Estándar",
  "cp.pages.settings.tableRowCompression": "Solo compresiones",
  "cp.pages.settings.tableRowDuration": "DURACIÓN DE LA SESIÓN",
  "cp.pages.settings.tableRowERC": "Compruebe si hay signos vitales",
  "cp.pages.settings.tableRowFeedback": "Modo de retroalimentación",
  "cp.pages.settings.tableRowFrequency": "Frecuencia objetivo",
  "cp.pages.settings.tableRowLocked": "Bloqueado",
  "cp.pages.settings.tableRowProperty": "Propiedad",
  "cp.pages.settings.tableRowResult": "Tipo de resultado",
  "cp.pages.settings.tableRowResultConfigSaveButton": "Guardar configuración de resultados",
  "cp.pages.settings.tableRowSaveButton": "Guardar",
  "cp.pages.settings.tableRowTrainees": "Número predeterminado de alumnos",
  "cp.pages.settings.tableRowType": "Tipo de sesión",
  "cp.pages.settings.tableRowValue": "Valor",
  "cp.pages.settings.title": "Configuraciones para CorPatch® Trainer",
  "cp.pages.sharingObject.form.apiAccess": "Acceso API",
  "cp.pages.sharingObject.form.confirmDeleteDialogMessage1": "¿Está seguro de que desea eliminar el objeto para compartir?",
  "cp.pages.sharingObject.form.confirmDeleteDialogMessage2": "Esta acción no se puede deshacer, pero no se perderá ningún dato. El objeto para compartir se mostrará como desactivado.",
  "cp.pages.sharingObject.form.confirmDeleteDialogNo": "Cancelar",
  "cp.pages.sharingObject.form.confirmDeleteDialogTitle": "Eliminar objeto de uso compartido",
  "cp.pages.sharingObject.form.confirmDeleteDialogYes": "Eliminar",
  "cp.pages.sharingObject.form.deleteButton": "Eliminar",
  "cp.pages.sharingObject.form.disabled": "Deshabilitado",
  "cp.pages.sharingObject.form.enabled": "Habilitado",
  "cp.pages.sharingObject.form.invitationCode": "Código de invitación",
  "cp.pages.sharingObject.form.invitationLink": "Enlace de invitación",
  "cp.pages.sharingObject.form.name": "Nombre",
  "cp.pages.sharingObject.form.pullApiSecret": "Secreto",
  "cp.pages.sharingObject.form.pullUrl": "Extraer URL",
  "cp.pages.sharingObject.form.saveButton": "Guardar",
  "cp.pages.sharingObject.form.title": "Objeto compartido",
  "cp.pages.sharingObject.form.webHook": "Webhook",
  "cp.pages.sharingObject.pageNotFoundDescription": "Los objetos para compartir que busca no existen.",
  "cp.pages.sharingObject.pageNotFoundTitle": "No encontrado",
  "cp.pages.sharingObject.pageTitle": "Compartir objetos",
  "cp.pages.sharingObject.snackBarDeleteError": "No se pudo eliminar",
  "cp.pages.sharingObject.snackBarDeleted": "Eliminado",
  "cp.pages.sharingObject.snackBarSaveError": "No se pudo guardar",
  "cp.pages.sharingObject.snackBarSaved": "Guardado",
  "cp.pages.singleTraining.multipleTrainings": "formaciones",
  "cp.pages.singleTraining.singleTraining": "formación",
  "cp.pages.singleTraining.table.created": "Creado",
  "cp.pages.singleTraining.table.name": "Nombre completo",
  "cp.pages.singleTraining.table.selected": "Seleccionado",
  "cp.pages.singleTraining.title": "Tus formaciones",
  "cp.pages.trainee.cpsButton": "Descargar datos de CorPatch®",
  "cp.pages.trainee.delete.errorSnackbar": "Se ha producido un error desconocido",
  "cp.pages.trainee.delete.successSnackbar": "Los alumnos se eliminaron correctamente",
  "cp.pages.trainee.delete.warningSnackbar": "No se eliminaron uno o más usuarios",
  "cp.pages.trainee.deleteDialogButtonPrimary": "Eliminar",
  "cp.pages.trainee.deleteDialogButtonSecondary": "Cerrar",
  "cp.pages.trainee.deleteLabel": "Eliminar",
  "cp.pages.trainee.mobileButton": "Descarga de datos de teléfonos inteligentes",
  "cp.pages.trainee.multipleTrainees": "alumnos",
  "cp.pages.trainee.singleTrainee": "alumno",
  "cp.pages.trainee.table.created": "Creado",
  "cp.pages.trainee.table.email": "Correo electrónico",
  "cp.pages.trainee.table.name": "Nombre completo",
  "cp.pages.trainee.table.selected": "Seleccionado",
  "cp.pages.trainee.title": "Alumnos",
  "cp.pages.traineeShares.active": "Activo",
  "cp.pages.traineeShares.addDialogAdd": "Añadir",
  "cp.pages.traineeShares.addDialogCancel": "Cancelar",
  "cp.pages.traineeShares.addDialogDescription": "Introduce el código de invitación que recibiste de tu organización asociada:",
  "cp.pages.traineeShares.addDialogDescription2": "Si eliges hacer clic en «Agregar», confirmas que aceptas los términos y condiciones y la política de privacidad que te proporcionó la organización asociada junto con este enlace/código de invitación. Es fundamental leerlos y entenderlos antes de continuar.",
  "cp.pages.traineeShares.addDialogTitle": "Invitación",
  "cp.pages.traineeShares.addShare": "Agregar compartir",
  "cp.pages.traineeShares.deactivateDialogDescription": "¿Estás seguro de que deseas desactivar este acuerdo de uso compartido con? {nombrecentroformación}",
  "cp.pages.traineeShares.deactivateDialogNo": "Cancelar",
  "cp.pages.traineeShares.deactivateDialogTitle": "Desactivar",
  "cp.pages.traineeShares.deactivateDialogYes": "Desactivar",
  "cp.pages.traineeShares.deactivateTooltip": "Desactivar",
  "cp.pages.traineeShares.endDate": "Fecha de finalización",
  "cp.pages.traineeShares.inactive": "Inactivo",
  "cp.pages.traineeShares.noActiveItemsMessage": "Actualmente, no ha aceptado ningún acuerdo de intercambio de datos. Pulsa el botón con el signo más en la parte inferior derecha para introducir el código de invitación correspondiente.",
  "cp.pages.traineeShares.noInactiveItemsMessage": "Sin acuerdos de intercambio inactivos.",
  "cp.pages.traineeShares.pageNotFoundMessage": "Las acciones para alumnos que está buscando no existen.",
  "cp.pages.traineeShares.pageTitle": "Acciones de alumnos",
  "cp.pages.traineeShares.pageTitleNotFound": "No encontrado",
  "cp.pages.traineeShares.snackBarErrorAddingInvitation": "Error al añadir la invitación:{errorMessage}!",
  "cp.pages.traineeShares.snackBarErrorDeactivatingSharing": "Error al desactivar el uso compartido:! {errorMessage}",
  "cp.pages.traineeShares.snackBarInvalidCode": "Introduce un código de invitación válido.",
  "cp.pages.traineeShares.snackBarInvitationAdded": "Invitación añadida",
  "cp.pages.traineeShares.snackBarSharingDeactivated": "Uso compartido desactivado",
  "cp.pages.traineeShares.startDate": "Fecha de inicio",
  "cp.pages.trainerInvite.errorSnackbar": "El correo electrónico ya se está utilizando",
  "cp.pages.trainerInvite.successSnackbar": "Enviar correo electrónico a {email}",
  "cp.pages.trainerInvite.title": "Invita a un instructor",
  "cp.pages.trainers.errorSnackbar": "No se pudo eliminar el usuario. ¡Vuelva a intentarlo!",
  "cp.pages.trainers.successSnackbar": "Eliminado",
  "cp.pages.trainersNotAvailable.button": "Invita a un instructor",
  "cp.pages.trainersNotAvailable.message": "¿Quieres invitar al primer instructor?",
  "cp.pages.trainersNotAvailable.title": "¡Aún no hay instructores!",
  "cp.pages.trainersNotFound.message": "Se ha eliminado este instructor. Lo siento :(",
  "cp.pages.trainersNotFound.title": "No se encontró el instructor",
  "cp.pages.trainersTable.deleteLabel": "Eliminar",
  "cp.pages.trainersTable.inviteTrainer": "Invita a un Instructor",
  "cp.pages.trainersTable.selected": "Seleccionado",
  "cp.pages.trainersTable.tableRowEmail": "Correo electrónico",
  "cp.pages.trainersTable.tableRowName": "Nombre",
  "cp.pages.trainersTable.trainers": "Instructores",
  "cp.pages.trainings.depth": "Depth",
  "cp.pages.trainings.flow": "Flow",
  "cp.pages.trainings.frequency": "Frequency",
  "cp.pages.trainings.notFound.message": "Has been deleted already. Sorry.",
  "cp.pages.trainings.notFound.title": "Not found",
  "cp.pages.trainings.recoil": "Recoil",
  "cp.pages.trainings.title": "Trainings",
  "cp.pages.trainings.trainee": "Trainee",
  "cp.pages.trainings.trainingNumber": "Training No.",
  "cp.pages.userChangeEmail.cancelButton": "Cancelar",
  "cp.pages.userChangeEmail.changeEmail": "Cambiar email",
  "cp.pages.userChangeEmail.email": "Email",
  "cp.pages.userChangeEmail.emailChangedSnackbar": "E-mail cambiado",
  "cp.pages.userChangeEmail.emailErrorSnackbar": "No se pudo cambiar el correo electrónico",
  "cp.pages.userChangeEmail.newEmail": "Nuevo correo electrónico",
  "cp.pages.userChangeEmail.notFound.message": "Este usuario ya no existe.",
  "cp.pages.userChangeEmail.notFound.title": "No encontrado",
  "cp.pages.userChangeEmail.ok": "OK",
  "cp.pages.userChangeEmail.sendEmail": "Email enviado",
  "cp.pages.userChangeEmail.verifyEmail.button": "Envíame un nuevo correo electrónico de verificación a mi dirección",
  "cp.pages.userChangeEmail.verifyEmail.content": "Queremos mantenerte informado sobre los últimos cambios en nuestra aplicación y nuestros productos. Por lo tanto, necesitamos verificar su dirección de correo electrónico.",
  "cp.pages.userChangeEmail.verifyEmail.title": "Verifica tu correo electrónico",
  "cp.pages.userChangePassword.notChangedPasswordSnackbar": "No se pudo cambiar la contraseña:",
  "cp.pages.userChangePassword.notFound.message": "Este usuario ha sido eliminado",
  "cp.pages.userChangePassword.notFound.title": "Usuario no encontrado",
  "cp.pages.userChangePassword.successSnackbar": "Contraseña cambiada",
  "cp.pages.userChangePassword.title": "Cambiar contraseña",
  "cp.pages.userChangePassword.wrongPasswordSnackbar": "La contraseña actual es incorrecta",
  "cp.pages.userDetails.errorSnackbar": "No se pudo enviar la invitación. ",
  "cp.pages.userDetails.invitation": "Invitación",
  "cp.pages.userDetails.notFound.message": "Se ha eliminado esta información. ",
  "cp.pages.userDetails.notFound.title": "No encontrado",
  "cp.pages.userDetails.sendInvitation": "Enviar invitación",
  "cp.pages.userDetails.signUpAccepted": "Aceptado",
  "cp.pages.userDetails.signUpPending": "Pendiente",
  "cp.pages.userDetails.successSnackbar": "Invitación enviada",
  "cp.pages.userDetails.userDetailsEmail": "Correo electrónico"
}